<ng-container
  *ngIf="activityData?.api"
>
  <mng-services-preview data="{{data}}"></mng-services-preview>
</ng-container>
